import { render, staticRenderFns } from "./AdminEditMara.vue?vue&type=template&id=604d7ae4"
import script from "./AdminEditMara.vue?vue&type=script&lang=js"
export * from "./AdminEditMara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports